// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/homepage/curveimage.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.carousel-wrapper {
  position: relative;
}

.carousel .control-dots {
  position: absolute;
  left: 50px;
  bottom: 10px;
  display: flex;
  flex-direction: row;
}
.ccarousel_image{
  height: 700px;
}
.video-btn-slider {
  border: none;
  position: absolute;
  z-index: 2;
  bottom: 14%;
  right: 2%;
  background: rgba(0,0,0,0.5);
}
.leaderboardbanner img{
  width: 100%;
}
.includedBanner img{
  width: 100%;
}
.dividerband{
  display: flex;
  align-items: center;
  justify-content: center;  background-color: #000;
  color: #FFF;
  height: 150px;
  font-size: 48px;

}
.dividerband2{
  display: flex;
  align-items: center;
  justify-content: center;  background-color:#BA1E24;
  color: #FFF;
  height: 150px;
  font-size: 48px;

}

/* .dividerband{  background-color: #000;
  /* display: flex; */
  /* justify-content: center;
  color: #FFF;
text-align: center;
font-family: Thicker;
font-size: 48px;
font-style: normal;
font-weight: 700;
padding-top: 80px;
padding-bottom: 20px;} */ 

.findYourRace{
  background-color: #BA1E24;
  display: flex;
  justify-content: center;
  color: #FFF;
text-align: center;
font-family: Thicker;
font-size: 48px;
font-style: normal;
font-weight: 700;
line-height: 111%; 
padding-top: 80px;
padding-bottom: 20px;
}
.carousel .control-dots .dot {
  margin-bottom: 10px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: white;
  transition: background-color 0.3s ease;
}
.carousel-slide img {
  height: 800px;
  object-fit: cover;
}
.carousel .control-dots .dot.selected {
  background-color: rgba(186, 30, 36, 1);
}
.slide-text-haeding {
  position: absolute;
  left: 50px;
  bottom: 250px;
  color: #ffffff;
  font-size: 34px;
  font-family: Thicker;
  font-weight: 600;
  background-color: rgba(186, 30, 36, 1);
  padding: 10px;
}
.slide-text-second-haeding {
  position: absolute;
  left: 50px;
  bottom: 170px;
  color: #ffffff;
  font-size: 34px;
  font-family: Thicker;
  font-weight: 600;
  background-color: rgba(186, 30, 36, 1);
  padding: 10px;
}
.slide-text-subheading {
  position: absolute;
  left: 50px;
  bottom: 110px;
  color: #ffffff;
  font-size: 24px;
  font-weight: bold;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 10px;
  cursor: pointer;
}
/* city css */
.city-image {
  width: 100%;
  margin-bottom: -7px;
}

.city-para {
  margin-left: 10%;
  margin-right: 10%;
  color: #000;
  text-align: center;
  font-family: Thicker;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 30px;
}
.card-image {
  position: relative;
}

.card-image img { 
  width: 100%;
  height: auto;
  display: block;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 10px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  opacity: 0;
  transition: opacity 0.3s ease;
  padding: 10px;
}
.knowMoreOverlay{
  position: absolute;
  top: 0;
  left: 0;
  bottom: 10px;
  width: 100%;
  height: 100%;
  display: flex; 
  flex-direction: row;
  justify-content: center;
  align-items: flex-end; 
  opacity: 0;
  transition: opacity 0.3s ease;
  padding: 10px;

}
.knowMoreOverlay>button{
  padding: 15px;
  color: #fff;
  width: 100%;
  font-family: Thicker;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 111%;
  text-transform: capitalize;
  border-radius: 0px;
}
.image-overlay > button {
  padding: 15px;
  color: #fff;
  font-family: Thicker;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 111%;
  text-transform: capitalize;
  border-radius: 0px;
}

.image-overlay:hover {
  opacity: 1;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1)); /* Gradient overlay */
}
.knowMoreOverlay:hover {
  opacity: 1;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1)); /* Gradient overlay */
 } 
.btn1 {
  margin: 5px;
  padding: 8px 12px;
  border: none;
  background-color: rgba(0, 0, 0, 1);
  color: #fff;
  cursor: pointer;
  outline: none;
  border: 1px solid #fff;
}
.knowBtn{
  margin: 5px;
  padding: 8px 12px;
  border: none;
  background-color: rgba(0, 0, 0, 1);
  color: #fff;
  cursor: pointer;
  outline: none;
  border: 1px solid #fff;
}
.btn2 {
  margin: 5px;
  padding: 8px 12px;
  border: 1px solid rgba(186, 30, 36, 1);
  background-color: rgba(186, 30, 36, 1);
  color: #fff;
  cursor: pointer;
  outline: none;
}

.city-card-container {
  background-color: #BA1E24;
  display: flex;
  overflow-x: auto;
  /* padding: 20px 0; */
  padding-top: 40px;
  padding-bottom: 100px;
  align-items: last baseline;
  scroll-behavior: smooth;
}

.city-card {
  z-index: 10;
  flex-shrink: 0;
  margin-right: 0px;
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.city-card > h3 {
  color: #fff;
  text-align: center;
  font-family: Thicker;
  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  text-transform: capitalize;
}
.city-card > p {
  color: #fff;
  text-align: center;
  font-family: Thicker;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
  text-transform: capitalize;
  margin-top: 10px;
  margin-bottom: 10px;
}
.city-card:last-child {
  margin-right: 0;
}

.city-card:nth-child(even) {
  height: 405px;
}
.city-card:nth-child(even) h3 {
  font-size: 36px;
  font-family: Thicker;
  color: #BA1E24;
  -webkit-text-fill-color: #BA1E24; 
  -webkit-text-stroke-width: 0.6px;
  -webkit-text-stroke-color: white;}
.city-card:nth-child(odd) {
  height: 470px;
}
.city-card-container::-webkit-scrollbar {
  display: none;
}

.carousel__item {
  position: absolute;
  width: 100%;
  padding: 0 12px;
  opacity: 0;
  filter: drop-shadow(0 2px 2px #555);
  will-change: "transform, opacity";
  animation: "carousel-animate-vertical 27s linear infinite";
}

.carousel__item-head {
  border-radius: "50%";
  background-color: "#d7f7fc";
  width: "90px";
  height: "90px";
  padding: "14px";
  position: "relative";
  margin-right: "-45px";
  flex-shrink: "0";
  display: "flex";
  align-items: "center";
  justify-content: "center";
  font-size: "50px";
}

.carousel__item-body {
  width: "100%";
  background-color: "#fff";
  border-radius: "8px";
  padding: "16px 20px 16px 70px";
}

.title {
  text-transform: uppercase;
  font-size: 20px;
  margin-top: 10px;
}
.prize-div {
  background: white;
  display: flex;
  justify-content: flex-end;
  translate: 0px -38px;
  transform: translate(0px, -39px); 
  width: 99%;
  transform: rotate(-2deg);
  height: 59px;
}
.whatyouGetOuterDiv {
  /* background-color: #18181a; */
}
.card-div {
  /* background: #18181a; */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: flex;
  justify-content: flex-end;
  translate: 0px -34px;
  /* transform: translate(0px, -32px); */
  width: 100%;
  transform: rotate(-0deg);
  height: 60px;
  margin-bottom: -2px;
}
.curveImage{
  margin-top: -200px;
  width: 100%;
  margin-bottom: -14px;
}
/* Add your CSS styles here */
.slider-teams {
  position: relative;
  top: 50%;
  left: 50%;
  max-width: 750px;
  opacity: 0;
  transform: translate(-50%, -50%);
}

.slider-teams_team {
  position: relative;
  overflow: hidden;
}

#list {
  position: relative;
  backface-visibility: hidden;
  transform: translate3d(0, 0, 0);
}

#list li {
  position: relative;
  display: inline-block;
  float: left;
  text-align: center;
}

#list li figure {
  cursor: pointer;
  margin: 1em;
  opacity: 0.5;
  transition: transform 450ms cubic-bezier(0.445, 0.05, 0.55, 0.95),
    opacity 450ms ease-in-out;
}

#list li figure:hover {
  opacity: 0.8;
  transform: scale(0.6) translateZ(0px);
}

#list li figure.active {
  opacity: 1;
  transform: scale(1) translateZ(0px);
}

#list li figure > div {
  border-radius: 5px;
  position: relative;
  margin: 2rem auto;
  width: 120px;
  height: 120px;
  overflow: hidden;
  transform: rotate(45deg) translateZ(0px);
}

#list li figure > div > div {
  background: url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/953/teams.jpg")
    no-repeat;
  background-size: cover;
  background-position: 0px 0px;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 170px;
  height: 170px;
  transform: rotate(-45deg) translate(0%, -70%);
}

#list li figcaption h2 {
  color: #333;
  font-size: 1.6rem;
  font-weight: 800;
}

#list li figcaption p {
  color: #666;
  font-size: 0.9rem;
  font-weight: 400;
}
.prize-image {
  width: 99.89%;
  z-index: 10;
  display: flex;
  justify-content: flex-end;
  translate: 0px -100px;
  transform: rotate(-2deg);
}

/* banner video */
.banner-video-container {
  position: relative;
  width: 100%;
  height: auto;
}

.banner-video {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.know-more-button {
  position: absolute;
  bottom: 100px;
  left: 90px;
  background-color: rgba(186, 30, 36, 1);
  color: #ffffff;
  padding: 10px 20px;
  border: none;
  border-radius: none;
  font-family: Thicker;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration: none;
  cursor: pointer;
}
.leftArrow,
.rightArrow {
  z-index: 15;
  color: white !important;
  height: 462px !important;
  width: 82px !important;
  background-color: transparent !important;
  position: relative !important;
  bottom: 430px !important;
  border-radius: 0px !important;
  border: none !important;
  overflow: hidden;
  position: relative;
}

.leftArrow::before,
.rightArrow::before {
  content: "";
  position: absolute;
  transform: translate(-50%, -50%);
  width: 50px;
  height: 50px;
  background-color: rgba(90, 90, 90, 1);
  border-radius: 50%;
  transition: transform 0.3s ease;
  opacity: 0;
  border: 1px solid white;
}

.leftArrow::before,
.rightArrow::before {
  opacity: 1; /* Show the circle overlay on hover */
}

.leftArrow svg,
.rightArrow svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.city-image_mobile{
    display: none;
}
.mobile_banner_container{
  display: none;
}
.banner-video-mobile{
  display: none;
}
.mobile-banner-content{
  display: none;
}

.band_img_div {
  width: 100%;
}

.band_img_div > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media screen and (min-width: 650px) and (max-width: 1024px) {
  .know-more-button {
    bottom: 50px;
    left: 50px;
  }

  .band_img_div {
   width: 100%;
   display: flex;
   align-items: center;
   justify-content: center;
   overflow: hidden;
   padding: 0 20px;
  }
  
  .band_img_div > img {
    width: 180%;
    height: 50px;
  }
}
@media screen and (max-width: 650px) {
  .ccarousel_image{
    height: 400px;
  }
  .video-btn-slider {
    border: none;
    position: absolute;
    z-index: 2;
    bottom: 4%;
    right: 2%;
    background: none;
  }
  .dividerband {
    height: 60px;
    font-size: 30px;
  }
  .dividerband2 {
    height: 60px;
    font-size: 30px;
  }
  .city-card-container {
    padding-top: 30px;
    padding-bottom: 60px;
  }
  .mobile-banner-container {
    /* background-image: url('../../assets/homepage/shop_background.png'); */
    background-color: #262626;
    background-size: cover;
    background-position: center;
    height: 300px; /* Adjust height as needed */
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: -50px;
}

.mobile-banner-content {
    text-align: center;
    color: white;
}
.mobile-banner-content{
  display: block;
}
.banner-heading {
  font-family: "lightThicker" !important;
    font-size: 16px;
    margin-bottom: 10px;
}

.banner-subheading {
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 400 !important;
}

.banner-button {
    padding: 10px 20px;
    font-size: 1rem;
    background-color:  rgba(186, 30, 36, 1); /* Example button color */
    color: white;
    border: none;
    border-radius: 0px;
    cursor: pointer;
}

.banner-video-mobile {
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover;
}
  .banner-video-container{
    display: none;
  }
  .city-card > h3 {
    font-size: 30px;
  }
  .city-image{
    display: none;
  }

  .city-container {
  margin-top: -70px;
}

  .city-image_mobile{
    display: block;
    width: 100%;
    margin-bottom: -2px;
  }
  .image-overlay{
    opacity: 1;
  }
  .knowMoreOverlay{
    opacity: 1;
  }
  .leftArrow,
.rightArrow {
  display: none;
}
  .carousel-slide img {
    height: 400px;
  }
  .slide-text-haeding {
    left: 20px;
    bottom: 150px;
    font-size: 16px;
  }
  .slide-text-second-haeding {
    left: 20px;
    bottom: 100px;
    font-size: 14px;
  }
  .slide-text-subheading {
    left: 20px;
    bottom: 60px;
    font-size: 14px;
  }
  .carousel .control-dots {
    bottom: 30px;
    left: 20px;
  }
  .prize-image {
    width: 100%;
    height: 50px;
  }
  .know-more-button {
    bottom: 20px;
    left: 50px;
    padding: 5px 10px;
    font-size: 12px;
  }
  .city-para {
    margin-bottom: 0px !important;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 20px !important;
  }


  .band_img_div {
    width: 100%;
    padding: 0 !important;
    overflow: hidden;
   }
   
   .band_img_div > img {
     width: 280% !important; 
     height: 50px !important;
     margin-left: -50px;
   }

}
/* responsive mobile */
.tagDiv{
   display: none; 
}
@media screen and (max-width: 450px) {
  .city-container {
    margin-top: 25px;
  }
  .tagDiv{
    display: flex;
    justify-content: flex-end;
    margin-top: -7px;
/* width: 70%; */
  }
  .tagDiv img{
    width: 60%;
  }
  .prize-image {
    display: none;
  }
  .city-para {
    margin-left: 16px;
    margin-right: 16px;
  }
  .prize-div {
    display: none;
  }
  .city-card:nth-child(even) {
    padding-top: 70px;
    height: 470px;
  }
  .city-card:nth-child(odd) {
    height: 470px;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/homepage/homepage.css"],"names":[],"mappings":";AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB,GAAG,sBAAsB;EAChD,WAAW;EACX,aAAa;EACb,eAAe;;AAEjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB,GAAG,wBAAwB;EAClD,WAAW;EACX,aAAa;EACb,eAAe;;AAEjB;;AAEA;qBACqB;EACnB;;;;;;;;wBAQsB;;AAExB;EACE,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb,kBAAkB;AAClB,oBAAoB;AACpB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB;AACjB,iBAAiB;AACjB,oBAAoB;AACpB;AACA;EACE,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,sCAAsC;EACtC,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,sCAAsC;EACtC,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,aAAa;EACb,eAAe;AACjB;AACA,aAAa;AACb;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,UAAU;EACV,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,UAAU;EACV,6BAA6B;EAC7B,aAAa;;AAEf;AACA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,0EAA0E,EAAE,qBAAqB;AACnG;AACA;EACE,UAAU;EACV,0EAA0E,EAAE,qBAAqB;CAClG;AACD;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kCAAkC;EAClC,WAAW;EACX,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kCAAkC;EAClC,WAAW;EACX,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,sCAAsC;EACtC,sCAAsC;EACtC,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,qBAAqB;EACrB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC,CAAC;AACnC;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,UAAU;EACV,mCAAmC;EACnC,iCAAiC;EACjC,0DAA0D;AAC5D;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,aAAa;EACb,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,gCAAgC;EAChC,UAAU;EACV,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,yDAA6D;EAC7D,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,sCAAsC;EACtC,WAAW;EACX,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;AACtB;AACA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ;6BAC2B;AAC7B;;AAEA;EACE,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE;aACW;EACX,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,sCAAsC;EACtC,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;AACA;;EAEE,WAAW;EACX,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,wCAAwC;EACxC,6BAA6B;EAC7B,wBAAwB;EACxB,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;EAC/B,UAAU;EACV,uBAAuB;AACzB;;AAEA;;EAEE,UAAU,EAAE,qCAAqC;AACnD;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA;IACI,aAAa;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;IACE,YAAY;IACZ,UAAU;EACZ;;EAEA;GACC,WAAW;GACX,aAAa;GACb,mBAAmB;GACnB,uBAAuB;GACvB,gBAAgB;GAChB,eAAe;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,wEAAwE;IACxE,yBAAyB;IACzB,sBAAsB;IACtB,2BAA2B;IAC3B,aAAa,EAAE,4BAA4B;IAC3C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,sCAAsC;IACpC,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,uCAAuC,EAAE,yBAAyB;IAClE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;;EAEA;EACA,iBAAiB;AACnB;;EAEE;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;;EAEA,aAAa;AACf;EACE;IACE,aAAa;EACf;EACA;IACE,UAAU;IACV,aAAa;IACb,eAAe;EACjB;EACA;IACE,UAAU;IACV,aAAa;IACb,eAAe;EACjB;EACA;IACE,UAAU;IACV,YAAY;IACZ,eAAe;EACjB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;EAChC;;;EAGA;IACE,WAAW;IACX,qBAAqB;IACrB,gBAAgB;GACjB;;GAEA;KACE,sBAAsB;KACtB,uBAAuB;KACvB,kBAAkB;GACpB;;AAEH;AACA,sBAAsB;AACtB;GACG,aAAa;AAChB;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB,gBAAgB;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,aAAa;EACf;;AAEF","sourcesContent":["\n.carousel-wrapper {\n  position: relative;\n}\n\n.carousel .control-dots {\n  position: absolute;\n  left: 50px;\n  bottom: 10px;\n  display: flex;\n  flex-direction: row;\n}\n.ccarousel_image{\n  height: 700px;\n}\n.video-btn-slider {\n  border: none;\n  position: absolute;\n  z-index: 2;\n  bottom: 14%;\n  right: 2%;\n  background: rgba(0,0,0,0.5);\n}\n.leaderboardbanner img{\n  width: 100%;\n}\n.includedBanner img{\n  width: 100%;\n}\n.dividerband{\n  display: flex;\n  align-items: center;\n  justify-content: center;  background-color: #000;\n  color: #FFF;\n  height: 150px;\n  font-size: 48px;\n\n}\n.dividerband2{\n  display: flex;\n  align-items: center;\n  justify-content: center;  background-color:#BA1E24;\n  color: #FFF;\n  height: 150px;\n  font-size: 48px;\n\n}\n\n/* .dividerband{  background-color: #000;\n  /* display: flex; */\n  /* justify-content: center;\n  color: #FFF;\ntext-align: center;\nfont-family: Thicker;\nfont-size: 48px;\nfont-style: normal;\nfont-weight: 700;\npadding-top: 80px;\npadding-bottom: 20px;} */ \n\n.findYourRace{\n  background-color: #BA1E24;\n  display: flex;\n  justify-content: center;\n  color: #FFF;\ntext-align: center;\nfont-family: Thicker;\nfont-size: 48px;\nfont-style: normal;\nfont-weight: 700;\nline-height: 111%; \npadding-top: 80px;\npadding-bottom: 20px;\n}\n.carousel .control-dots .dot {\n  margin-bottom: 10px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: white;\n  transition: background-color 0.3s ease;\n}\n.carousel-slide img {\n  height: 800px;\n  object-fit: cover;\n}\n.carousel .control-dots .dot.selected {\n  background-color: rgba(186, 30, 36, 1);\n}\n.slide-text-haeding {\n  position: absolute;\n  left: 50px;\n  bottom: 250px;\n  color: #ffffff;\n  font-size: 34px;\n  font-family: Thicker;\n  font-weight: 600;\n  background-color: rgba(186, 30, 36, 1);\n  padding: 10px;\n}\n.slide-text-second-haeding {\n  position: absolute;\n  left: 50px;\n  bottom: 170px;\n  color: #ffffff;\n  font-size: 34px;\n  font-family: Thicker;\n  font-weight: 600;\n  background-color: rgba(186, 30, 36, 1);\n  padding: 10px;\n}\n.slide-text-subheading {\n  position: absolute;\n  left: 50px;\n  bottom: 110px;\n  color: #ffffff;\n  font-size: 24px;\n  font-weight: bold;\n  background-color: rgba(0, 0, 0, 0.5);\n  padding: 10px;\n  cursor: pointer;\n}\n/* city css */\n.city-image {\n  width: 100%;\n  margin-bottom: -7px;\n}\n\n.city-para {\n  margin-left: 10%;\n  margin-right: 10%;\n  color: #000;\n  text-align: center;\n  font-family: Thicker;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n  margin-bottom: 30px;\n}\n.card-image {\n  position: relative;\n}\n\n.card-image img { \n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.image-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 10px;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: flex-end;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  padding: 10px;\n}\n.knowMoreOverlay{\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 10px;\n  width: 100%;\n  height: 100%;\n  display: flex; \n  flex-direction: row;\n  justify-content: center;\n  align-items: flex-end; \n  opacity: 0;\n  transition: opacity 0.3s ease;\n  padding: 10px;\n\n}\n.knowMoreOverlay>button{\n  padding: 15px;\n  color: #fff;\n  width: 100%;\n  font-family: Thicker;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 111%;\n  text-transform: capitalize;\n  border-radius: 0px;\n}\n.image-overlay > button {\n  padding: 15px;\n  color: #fff;\n  font-family: Thicker;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 111%;\n  text-transform: capitalize;\n  border-radius: 0px;\n}\n\n.image-overlay:hover {\n  opacity: 1;\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1)); /* Gradient overlay */\n}\n.knowMoreOverlay:hover {\n  opacity: 1;\n  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1)); /* Gradient overlay */\n } \n.btn1 {\n  margin: 5px;\n  padding: 8px 12px;\n  border: none;\n  background-color: rgba(0, 0, 0, 1);\n  color: #fff;\n  cursor: pointer;\n  outline: none;\n  border: 1px solid #fff;\n}\n.knowBtn{\n  margin: 5px;\n  padding: 8px 12px;\n  border: none;\n  background-color: rgba(0, 0, 0, 1);\n  color: #fff;\n  cursor: pointer;\n  outline: none;\n  border: 1px solid #fff;\n}\n.btn2 {\n  margin: 5px;\n  padding: 8px 12px;\n  border: 1px solid rgba(186, 30, 36, 1);\n  background-color: rgba(186, 30, 36, 1);\n  color: #fff;\n  cursor: pointer;\n  outline: none;\n}\n\n.city-card-container {\n  background-color: #BA1E24;\n  display: flex;\n  overflow-x: auto;\n  /* padding: 20px 0; */\n  padding-top: 40px;\n  padding-bottom: 100px;\n  align-items: last baseline;\n  scroll-behavior: smooth;\n}\n\n.city-card {\n  z-index: 10;\n  flex-shrink: 0;\n  margin-right: 0px;\n  padding: 20px 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.city-card > h3 {\n  color: #fff;\n  text-align: center;\n  font-family: Thicker;\n  font-size: 36px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 100%;\n  text-transform: capitalize;\n}\n.city-card > p {\n  color: #fff;\n  text-align: center;\n  font-family: Thicker;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 100%;\n  text-transform: capitalize;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.city-card:last-child {\n  margin-right: 0;\n}\n\n.city-card:nth-child(even) {\n  height: 405px;\n}\n.city-card:nth-child(even) h3 {\n  font-size: 36px;\n  font-family: Thicker;\n  color: #BA1E24;\n  -webkit-text-fill-color: #BA1E24; \n  -webkit-text-stroke-width: 0.6px;\n  -webkit-text-stroke-color: white;}\n.city-card:nth-child(odd) {\n  height: 470px;\n}\n.city-card-container::-webkit-scrollbar {\n  display: none;\n}\n\n.carousel__item {\n  position: absolute;\n  width: 100%;\n  padding: 0 12px;\n  opacity: 0;\n  filter: drop-shadow(0 2px 2px #555);\n  will-change: \"transform, opacity\";\n  animation: \"carousel-animate-vertical 27s linear infinite\";\n}\n\n.carousel__item-head {\n  border-radius: \"50%\";\n  background-color: \"#d7f7fc\";\n  width: \"90px\";\n  height: \"90px\";\n  padding: \"14px\";\n  position: \"relative\";\n  margin-right: \"-45px\";\n  flex-shrink: \"0\";\n  display: \"flex\";\n  align-items: \"center\";\n  justify-content: \"center\";\n  font-size: \"50px\";\n}\n\n.carousel__item-body {\n  width: \"100%\";\n  background-color: \"#fff\";\n  border-radius: \"8px\";\n  padding: \"16px 20px 16px 70px\";\n}\n\n.title {\n  text-transform: uppercase;\n  font-size: 20px;\n  margin-top: 10px;\n}\n.prize-div {\n  background: white;\n  display: flex;\n  justify-content: flex-end;\n  translate: 0px -38px;\n  transform: translate(0px, -39px); \n  width: 99%;\n  transform: rotate(-2deg);\n  height: 59px;\n}\n.whatyouGetOuterDiv {\n  /* background-color: #18181a; */\n}\n.card-div {\n  /* background: #18181a; */\n  background-image: url(\"../../assets/homepage/curveimage.png\");\n  display: flex;\n  justify-content: flex-end;\n  translate: 0px -34px;\n  /* transform: translate(0px, -32px); */\n  width: 100%;\n  transform: rotate(-0deg);\n  height: 60px;\n  margin-bottom: -2px;\n}\n.curveImage{\n  margin-top: -200px;\n  width: 100%;\n  margin-bottom: -14px;\n}\n/* Add your CSS styles here */\n.slider-teams {\n  position: relative;\n  top: 50%;\n  left: 50%;\n  max-width: 750px;\n  opacity: 0;\n  transform: translate(-50%, -50%);\n}\n\n.slider-teams_team {\n  position: relative;\n  overflow: hidden;\n}\n\n#list {\n  position: relative;\n  backface-visibility: hidden;\n  transform: translate3d(0, 0, 0);\n}\n\n#list li {\n  position: relative;\n  display: inline-block;\n  float: left;\n  text-align: center;\n}\n\n#list li figure {\n  cursor: pointer;\n  margin: 1em;\n  opacity: 0.5;\n  transition: transform 450ms cubic-bezier(0.445, 0.05, 0.55, 0.95),\n    opacity 450ms ease-in-out;\n}\n\n#list li figure:hover {\n  opacity: 0.8;\n  transform: scale(0.6) translateZ(0px);\n}\n\n#list li figure.active {\n  opacity: 1;\n  transform: scale(1) translateZ(0px);\n}\n\n#list li figure > div {\n  border-radius: 5px;\n  position: relative;\n  margin: 2rem auto;\n  width: 120px;\n  height: 120px;\n  overflow: hidden;\n  transform: rotate(45deg) translateZ(0px);\n}\n\n#list li figure > div > div {\n  background: url(\"https://s3-us-west-2.amazonaws.com/s.cdpn.io/953/teams.jpg\")\n    no-repeat;\n  background-size: cover;\n  background-position: 0px 0px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 170px;\n  height: 170px;\n  transform: rotate(-45deg) translate(0%, -70%);\n}\n\n#list li figcaption h2 {\n  color: #333;\n  font-size: 1.6rem;\n  font-weight: 800;\n}\n\n#list li figcaption p {\n  color: #666;\n  font-size: 0.9rem;\n  font-weight: 400;\n}\n.prize-image {\n  width: 99.89%;\n  z-index: 10;\n  display: flex;\n  justify-content: flex-end;\n  translate: 0px -100px;\n  transform: rotate(-2deg);\n}\n\n/* banner video */\n.banner-video-container {\n  position: relative;\n  width: 100%;\n  height: auto;\n}\n\n.banner-video {\n  width: 100%;\n  height: auto;\n  object-fit: cover;\n}\n\n.know-more-button {\n  position: absolute;\n  bottom: 100px;\n  left: 90px;\n  background-color: rgba(186, 30, 36, 1);\n  color: #ffffff;\n  padding: 10px 20px;\n  border: none;\n  border-radius: none;\n  font-family: Thicker;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-decoration: none;\n  cursor: pointer;\n}\n.leftArrow,\n.rightArrow {\n  z-index: 15;\n  color: white !important;\n  height: 462px !important;\n  width: 82px !important;\n  background-color: transparent !important;\n  position: relative !important;\n  bottom: 430px !important;\n  border-radius: 0px !important;\n  border: none !important;\n  overflow: hidden;\n  position: relative;\n}\n\n.leftArrow::before,\n.rightArrow::before {\n  content: \"\";\n  position: absolute;\n  transform: translate(-50%, -50%);\n  width: 50px;\n  height: 50px;\n  background-color: rgba(90, 90, 90, 1);\n  border-radius: 50%;\n  transition: transform 0.3s ease;\n  opacity: 0;\n  border: 1px solid white;\n}\n\n.leftArrow::before,\n.rightArrow::before {\n  opacity: 1; /* Show the circle overlay on hover */\n}\n\n.leftArrow svg,\n.rightArrow svg {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.city-image_mobile{\n    display: none;\n}\n.mobile_banner_container{\n  display: none;\n}\n.banner-video-mobile{\n  display: none;\n}\n.mobile-banner-content{\n  display: none;\n}\n\n.band_img_div {\n  width: 100%;\n}\n\n.band_img_div > img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n@media screen and (min-width: 650px) and (max-width: 1024px) {\n  .know-more-button {\n    bottom: 50px;\n    left: 50px;\n  }\n\n  .band_img_div {\n   width: 100%;\n   display: flex;\n   align-items: center;\n   justify-content: center;\n   overflow: hidden;\n   padding: 0 20px;\n  }\n  \n  .band_img_div > img {\n    width: 180%;\n    height: 50px;\n  }\n}\n@media screen and (max-width: 650px) {\n  .ccarousel_image{\n    height: 400px;\n  }\n  .video-btn-slider {\n    border: none;\n    position: absolute;\n    z-index: 2;\n    bottom: 4%;\n    right: 2%;\n    background: none;\n  }\n  .dividerband {\n    height: 60px;\n    font-size: 30px;\n  }\n  .dividerband2 {\n    height: 60px;\n    font-size: 30px;\n  }\n  .city-card-container {\n    padding-top: 30px;\n    padding-bottom: 60px;\n  }\n  .mobile-banner-container {\n    /* background-image: url('../../assets/homepage/shop_background.png'); */\n    background-color: #262626;\n    background-size: cover;\n    background-position: center;\n    height: 300px; /* Adjust height as needed */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: -50px;\n}\n\n.mobile-banner-content {\n    text-align: center;\n    color: white;\n}\n.mobile-banner-content{\n  display: block;\n}\n.banner-heading {\n  font-family: \"lightThicker\" !important;\n    font-size: 16px;\n    margin-bottom: 10px;\n}\n\n.banner-subheading {\n    font-size: 20px;\n    margin-bottom: 20px;\n    font-weight: 400 !important;\n}\n\n.banner-button {\n    padding: 10px 20px;\n    font-size: 1rem;\n    background-color:  rgba(186, 30, 36, 1); /* Example button color */\n    color: white;\n    border: none;\n    border-radius: 0px;\n    cursor: pointer;\n}\n\n.banner-video-mobile {\n  display: block;\n  width: 100%;\n  height: auto;\n  object-fit: cover;\n}\n  .banner-video-container{\n    display: none;\n  }\n  .city-card > h3 {\n    font-size: 30px;\n  }\n  .city-image{\n    display: none;\n  }\n\n  .city-container {\n  margin-top: -70px;\n}\n\n  .city-image_mobile{\n    display: block;\n    width: 100%;\n    margin-bottom: -2px;\n  }\n  .image-overlay{\n    opacity: 1;\n  }\n  .knowMoreOverlay{\n    opacity: 1;\n  }\n  .leftArrow,\n.rightArrow {\n  display: none;\n}\n  .carousel-slide img {\n    height: 400px;\n  }\n  .slide-text-haeding {\n    left: 20px;\n    bottom: 150px;\n    font-size: 16px;\n  }\n  .slide-text-second-haeding {\n    left: 20px;\n    bottom: 100px;\n    font-size: 14px;\n  }\n  .slide-text-subheading {\n    left: 20px;\n    bottom: 60px;\n    font-size: 14px;\n  }\n  .carousel .control-dots {\n    bottom: 30px;\n    left: 20px;\n  }\n  .prize-image {\n    width: 100%;\n    height: 50px;\n  }\n  .know-more-button {\n    bottom: 20px;\n    left: 50px;\n    padding: 5px 10px;\n    font-size: 12px;\n  }\n  .city-para {\n    margin-bottom: 0px !important;\n    margin-left: 20px;\n    margin-right: 20px;\n    margin-bottom: 20px !important;\n  }\n\n\n  .band_img_div {\n    width: 100%;\n    padding: 0 !important;\n    overflow: hidden;\n   }\n   \n   .band_img_div > img {\n     width: 280% !important; \n     height: 50px !important;\n     margin-left: -50px;\n   }\n\n}\n/* responsive mobile */\n.tagDiv{\n   display: none; \n}\n@media screen and (max-width: 450px) {\n  .city-container {\n    margin-top: 25px;\n  }\n  .tagDiv{\n    display: flex;\n    justify-content: flex-end;\n    margin-top: -7px;\n/* width: 70%; */\n  }\n  .tagDiv img{\n    width: 60%;\n  }\n  .prize-image {\n    display: none;\n  }\n  .city-para {\n    margin-left: 16px;\n    margin-right: 16px;\n  }\n  .prize-div {\n    display: none;\n  }\n  .city-card:nth-child(even) {\n    padding-top: 70px;\n    height: 470px;\n  }\n  .city-card:nth-child(odd) {\n    height: 470px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
